import { useCallback, useEffect, useMemo, useState } from 'react';
import { triageApi } from '../api/triage';

/**
 * Batch-load AI triage verdicts for a list of keys such as "ioc:12",
 * "cve:3", "finding:fnd-ab12". Re-fetches only when the SET of keys changes.
 * Failures are silent: the pages must work without verdicts.
 */
export function useVerdicts(keys) {
  const [verdicts, setVerdicts] = useState({});
  const signature = useMemo(() => [...new Set(keys)].sort().join(','), [keys]);

  useEffect(() => {
    if (!signature) return undefined;
    let alive = true;
    triageApi
      .getVerdicts(signature.split(','))
      .then((v) => alive && setVerdicts(v || {}))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [signature]);

  const setVerdict = useCallback((key, verdict) => {
    setVerdicts((prev) => ({ ...prev, [key]: verdict }));
  }, []);

  return { verdicts, setVerdict };
}
